export enum RecordStatus
{
    Active,
    Inactive,
    Deleted
    
}